<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.53613 2.4375C10.0757 -0.229018 13.9242 -0.228967 15.4639 2.4375L22.7168 15C24.2564 17.6667 22.3321 21 19.2529 21H4.74707C1.66797 20.9999 -0.25631 17.6666 1.2832 15L8.53613 2.4375ZM13.7324 3.4375C12.9626 2.10423 11.0374 2.10419 10.2676 3.4375L3.01465 16C2.24509 17.3333 3.20763 18.9999 4.74707 19H19.2529C20.7925 19 21.755 17.3333 20.9854 16L13.7324 3.4375ZM12 15C12.5522 15 13 15.4477 13 16C13 16.5523 12.5522 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15ZM12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4478 12.9999 11 12.5522 11 12V8C11 7.44776 11.4478 7.00008 12 7Z"
      fill="currentColor"
    />
  </svg>
</template>
